import { FC, ReactNode, useRef, useState } from 'react';
import { useKeyboardShortcut, useOutsideAlerter } from 'src/hooks';
import { defineMessages, useIntl } from 'react-intl';
import { Tooltip } from 'src/components';
import Icon from '../Icon';
import * as S from './styles';

interface InfoTooltipModalProps {
  tooltip: ReactNode;
  label?: ReactNode;
}

const msgs = defineMessages({
  info: {
    id: 'card_statistics_link_see_more',
  },
});

const InfoTooltipModal: FC<InfoTooltipModalProps> = ({ tooltip, label }) => {
  const [isTooltipModalOpen, setTooltipModalOpen] = useState(false);
  const ref = useRef(null);
  useKeyboardShortcut('esc', () => setTooltipModalOpen(false));
  useOutsideAlerter(ref, () => setTooltipModalOpen(false));

  const intl = useIntl();
  const infoText = intl.formatMessage(msgs.info);
  return (
    <div ref={ref} aria-label={infoText}>
      <Tooltip tooltip={tooltip} forceShow={isTooltipModalOpen} tooltipStyle="hint">
        <S.InfoBubble title={infoText} onClick={() => setTooltipModalOpen(!isTooltipModalOpen)}>
          <Icon name="infoOutline" />
          {label && <S.Label>{label}</S.Label>}
        </S.InfoBubble>
      </Tooltip>
    </div>
  );
};

export { InfoTooltipModal };
